import PropTypes from "prop-types";

import { useSignUpVersion } from "./hooks";

function SignUpVersion({ children, requireVersion }) {
  const signUpVersion = useSignUpVersion();

  if (requireVersion === signUpVersion) return children;
  return null;
}

SignUpVersion.propTypes = {
  children: PropTypes.node,
  requireVersion: PropTypes.string,
};

SignUpVersion.defaultProps = {
  requireVersion: "",
  children: null,
};

export default SignUpVersion;
